import { SERVER_ACTION } from "@/store/action-types";
import Swal from "sweetalert2";
export default {

    data() {
        return {
            userCanManageBroadcasting: true,
            status: {
                processing: false,
                restarting: false,
                reloading: false,
            },
            startUri: "admin/services/frontend/start",
            restartUri: "admin/services/frontend/restart",
            reloadUri: "admin/services/frontend/reload",
            stopUri: "admin/services/frontend/stop",
        };
    },

    methods: {
        async serverAction(uri, key) {

            if (uri == this.startUri && !this.station.is_playable) {
                
                    swal.fire({
                        text: `To start the station, you must first upload a minimum of one MP3 file and then include it in a playlist.`,
                        confirmButtonText: "ok",
                        confirmButtonColor: "#e64942",
                        showCancelButton: false,
                        focusCancel: true,
                      }).then((result) => {
                          this.$router.push("/files", () => {});
                        
                      });
                
            } else {

                try {
                    this.status[key] = true;
                    await this.$store.dispatch(SERVER_ACTION, uri);
                    this.status[key] = false;
                    $station.needs_restart = 0
    
                } catch (error) {
                    this.status[key] = false;
                }

            }


            
        },
    }
}